/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from '@ember/component';
import { service } from '@ember/service';

export default class GoalsSection extends Component {
  // Services
  @service
  store;

  @service
  strings;

  // learnerSummaries is a map of subjectId to learnerSummary.
  learnerSummaries = null;

  // hideHeader hides the section label when true.
  hideHeader = false;
}
